module.exports = __webpack_public_path__ + "img/send.42ac3f4c.svg";